







































































































































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import EventBus from '@/plugins/EventBus'
import ResponseApi from '@/types/interfaces/FactoryResponse'


@Component
export default class ComponentModalFiltroDownloadNotasFiscais extends Vue {
  loadEmitirRelatorio: boolean = false
  menuAnoMesReferencia: boolean = false
  menuDe: boolean = false
  menuAte: boolean = false
  textDe: string = ''
  textAte: string = ''

  $refs!: {
    menuAnoMesReferencia: any,
    menuDe: any,
    menuAte: any,
  }

  get modalFiltroDownloadNotaFiscal() { return this.getFinanceiroStore.modal.filtroDownloadNotaFiscal }
  set modalFiltroDownloadNotaFiscal(value: boolean) { this.getFinanceiroStore.setModal({ name: 'filtroDownloadNotaFiscal', value }) }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get loadingNotaFiscal() {
    return this.loadEmitirRelatorio
  }

  set loadingNotaFiscal(value: boolean) {
    this.loadEmitirRelatorio = value
  }

  get getMenuAnoMesReferencia() {
    return this.menuAnoMesReferencia
  }

  set getMenuAnoMesReferencia(value: boolean) {
    this.menuAnoMesReferencia = value
  }

  get getMenuDe() {
    return this.menuDe
  }

  set getMenuDe(value: boolean) {
    this.menuDe = value
  }

  get getMenuAte() {
    return this.menuAte
  }

  set getMenuAte(value: boolean) {
    this.menuAte = value
  }

  get anoMesReferenciaDownloadNotasFiscais() {
    return this.getFinanceiroStore.anoMesReferenciaDownloadNotasFiscais
  }

  set anoMesReferenciaDownloadNotasFiscais(value: string) {
    this.getFinanceiroStore.setAnoMesReferenciaDownloadNotasFiscais(value)
  }

  get createdOnNFDe() {
    return this.getFinanceiroStore.createdOnNFDe
  }

  set createdOnNFDe(value: string) {
    this.getFinanceiroStore.setCreatedOnNFDe(value)
  }

  get createdOnNFAte() {
    return this.getFinanceiroStore.createdOnNFAte
  }

  set createdOnNFAte(value: string) {
    this.getFinanceiroStore.setCreatedOnNFAte(value)
  }

  get onlyTextDe() {
    return this.textDe
  }

  set onlyTextDe(value: string) {
    this.textDe = value
  }

  get onlyTextAte() {
    return this.textAte
  }

  set onlyTextAte(value: string) {
    this.textAte = value
  }

  get fontePagadoraIdDownloadNotasFiscais() {
    return this.getFinanceiroStore.fontePagadoraIdDownloadNotasFiscais
  }

  set fontePagadoraIdDownloadNotasFiscais(value: string) {
    this.getFinanceiroStore.setFontePagadoraIdDownloadNotasFiscais(value)
  }

  get grupoRepasseDownloadNotasFiscais() {
    return this.getFinanceiroStore.grupoRepasseDownloadNotasFiscais
  }

  set grupoRepasseDownloadNotasFiscais(value: string) {
    this.getFinanceiroStore.setGrupoRepasseDownloadNotasFiscais(value)
  }

  get situacoesDoRepasseDownloadNotasFiscais() {
    return this.getFinanceiroStore.situacoesDoRepasseDownloadNotasFiscais
  }

  set situacoesDoRepasseDownloadNotasFiscais(value: string) {
    this.getFinanceiroStore.setSituacoesDoRepasseDownloadNotasFiscais(value)
  }

  get getFontePagadorasDownloadNotasFiscais() {
    return this.getFinanceiroStore.fontePagadoras
  }

  set getFontePagadorasDownloadNotasFiscais(value: any[]) {
    this.getFinanceiroStore.setFontePagadora(value)
  }

  get getGrupoRepassesDownloadNotasFiscais() {
    return this.getFinanceiroStore.grupoRepasseItensAll
  }

  set getGrupoRepassesDownloadNotasFiscais(value: any[]) {
    this.getFinanceiroStore.setGrupoRepasseItensAll(value)
  }

  get getSituacoesDoRepasseDownloadNotasFiscais() {
    return [
      { key: 'Todos', display: 'Todos' },
      { key: 'Pendente', display: 'Pendente' },
      { key: 'Divergente', display: 'Divergente' },
      { key: 'Provisionada', display: 'Provisionada' },
      { key: 'ValidacaoPendente', display: 'Validação pendente' },
      { key: 'Validada', display: 'Validada' },
      { key: 'Paga', display: 'Paga' },
      { key: 'EnviadoParaPagamento', display: 'Enviado para pagamento' },
    ]
  }

  closeModalFiltroDownloadNotaFiscal() {
    this.getFinanceiroStore.clearDownloadNotas()
    this.onlyTextDe = ''
    this.onlyTextAte = ''
    this.modalFiltroDownloadNotaFiscal = false
  }

  updateDe(date: string) {
    this.onlyTextDe = this.formatDate(date)
    this.getMenuDe = false
  }

  updateAte(date: string) {
    this.onlyTextAte = this.formatDate(date)
    this.getMenuAte = false
  }

  formatDate(date: string) {
  // eslint-disable-next-line
    if (!date || isNaN(Date.parse(date))) return ''
    const [year, month, day] = date.split('-')
    return `${day}-${month}-${year}`
  }

  async filtroDownloadNotaFiscal() {
    this.loadingNotaFiscal = true
    let response: ResponseApi<any> | any = {}

    if (this.anoMesReferenciaDownloadNotasFiscais === '') {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione um ano/mês de referencia para realizar o donwload.', icon: 'warning', color: '#C62828' })
      this.loadingNotaFiscal = false
      return
    }

    response = await this.getFinanceiroStore.filtroDownloadNotaFiscal()

    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Download concluído com sucesso!', icon: 'done', color: '#2E7D32' })
      await this.getFinanceiroStore.getItemsDownloadNotasFiscais()
      this.closeModalFiltroDownloadNotaFiscal()
    } else {
      if (response.errors && response.errors.length > 0) {
        const errorMessage = response.errors[0].message || 'Ocorreu um erro ao realizar o download.'
        EventBus.$emit('setSnackbar', { show: true, text: errorMessage, icon: 'warning', color: '#C62828' })
      } else {
        const mainMessage = response.message || 'Ocorreu um erro ao realizar o download.'
        EventBus.$emit('setSnackbar', { show: true, text: mainMessage, icon: 'warning', color: '#C62828' })
      }
      this.loadingNotaFiscal = false
    }
    this.loadingNotaFiscal = false
  }
}
